const groupCells = [
  {
    id: 'name',
    label: 'Name',
    width: 180,
    align: 'left',
  },
  {
    id: 'parent',
    numeric: true,
    label: 'Parent',
    width: 230,
    align: 'right',
  },
  {
    id: 'members',
    numeric: true,
    label: 'Members',
    width: 180,
    align: 'center',
  },
  {
    id: 'action',
    numeric: false,
    label: 'Info',
    width: 50,
    align: 'center',
  },
];

const userCells = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    width: 200,
  },
  {
    id: 'role',
    numeric: true,
    label: 'Role',
    width: 150,
    align: 'right',
  },
  {
    id: 'email',
    numeric: true,
    label: 'Email',
    width: 230,
    align: 'right',
  },
  {
    id: 'action',
    numeric: false,
    label: 'Info',
    width: 80,
    align: 'center',
  },
];

const userCellsWithGroup = [
  {
    id: 'name',
    label: 'Name',
    align: 'left',
    width: 180,
  },
  {
    id: 'role',
    numeric: true,
    label: 'Role',
    width: 230,
    align: 'right',
  },
  {
    id: 'email',
    numeric: true,
    label: 'Email',
    width: 230,
    align: 'right',
  },
  {
    id: 'groups',
    numeric: true,
    label: 'Groups',
    width: 180,
    align: 'right',
  },
  {
    id: 'action',
    numeric: false,
    label: 'Info',
    width: 50,
    align: 'center',
  },
];

export const initialState = {
  groupCells,
  userCells,
  userCellsWithGroup,
  users: {
    loading: false,
    value: [],
    next: null,
  },
  selectedUser: null,
  selectedGroup: {
    value: {},
    members: {
      value: [],
      canLoadMore: false,
      offset: 0,
    },
    memberSearch: {
      canLoadMore: false,
      query: '',
      value: [],
      offset: 0,
    },
    loading: false,
    loadingSearch: false,
  },
  brand: {
    loading: false,
    value: {},
    updating: false,
  },
  brandGroups: {
    value: [],
    loading: false,
    updating: false,
  },
  brandStat: {
    value: {},
    loading: false,
  },
  brandUsers: {
    table: {
      value: [],
      canLoadMore: false,
      loading: false,
      searchLoading: false,
    },
    selector: {
      value: [],
      canLoadMore: false,
      loading: false,
    },
    updating: false,
  },
  userList: {
    value: [],
    loading: false,
  },
  updatingAdmins: false,
  updatingMembers: false,
  userSize: 10,
  searchSize: 5,
  subscription: {
    value: {
      stripe_id: '',
      qty: '',
      unit_price_in_cents: '',
      unit_price: '',
      total_price: '',
      status: '',
    },
    loading: false,
  },
  subscriptionStripe: {
    value: {
      id: '',
      url: '',
    },
    loading: false,
  },
};
